import { LabelSettings } from './LabelSettings';
import { FormattingSettings } from './FormattingSettings';
import { t, type I18nLocale } from '@ardoq/i18n';
import {
  SectionTitle,
  SectionHeader,
  SectionDescription,
  SectionContainer,
} from './atoms';
import { AppliedSettingsData } from './types';
import { GroupSettings } from './GroupSettings';
import { ContextComponentType } from './ContextComponentType';
import { ComponentAndReferenceTypes } from './ComponentsAndReferencesTypes';
import { FiltersSettings } from './FiltersSettings';
import { LabelSettingsWithMultiselect } from './LabelSettingsWithMultiselect';

type Props = {
  appliedSettings: AppliedSettingsData;
  i18nLocale: I18nLocale;
};

export const AppliedSettings = ({
  appliedSettings: {
    labelSettings,
    formattingSettings,
    groupingSettings,
    contextComponentTypeSettings,
    componentAndReferenceTypesSettings,
    filterSettings,
  },
  i18nLocale,
}: Props) => (
  <SectionContainer>
    <SectionHeader>
      <SectionTitle>
        {t(i18nLocale, 'appLayout:viewpointSetupTitle', 'Viewpoint setup')}
      </SectionTitle>
      <SectionDescription>
        {t(
          i18nLocale,
          'appLayout:viewpointSetupDescription',
          'Hover on the tags to see what will be saved in this viewpoint'
        )}
      </SectionDescription>
    </SectionHeader>
    <ContextComponentType
      settings={contextComponentTypeSettings}
      i18nLocale={i18nLocale}
    />
    <ComponentAndReferenceTypes
      settings={componentAndReferenceTypesSettings}
      i18nLocale={i18nLocale}
    />
    <FiltersSettings settings={filterSettings} i18nLocale={i18nLocale} />
    <GroupSettings settings={groupingSettings} i18nLocale={i18nLocale} />
    <FormattingSettings settings={formattingSettings} i18nLocale={i18nLocale} />
    {'labelFormatting' in labelSettings ? (
      <LabelSettingsWithMultiselect
        settings={labelSettings}
        i18nLocale={i18nLocale}
      />
    ) : (
      <LabelSettings settings={labelSettings} i18nLocale={i18nLocale} />
    )}
  </SectionContainer>
);
